import { IQueryContext } from 'framework/context/IQueryContext';
import { INoahUserSetup, INoahUserSetupsQueryMetadata, INoahUserSetupsQueryParams, IQueryResultWithMetadata } from 'gen/ApiClient';
import React from 'react';

export const NoahUserSetupsQueryContext = React.createContext<
	IQueryContext<IQueryResultWithMetadata<INoahUserSetup, INoahUserSetupsQueryMetadata>, INoahUserSetupsQueryParams>
>(undefined as any);
